import React, { FC, Fragment, useContext, useState } from 'react';
import clsx from 'clsx';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import MenuIcon from '@material-ui/icons/Menu';
import { AccountCircle } from '@material-ui/icons' //used for future profile picture 
import { ReactComponent as SvgLogout } from '../../../routes/icons/logout.svg';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { ListItem, ListItemIcon, SvgIcon, Menu, MenuItem, ListItemText } from '@material-ui/core';
import Copyright from '../../Copyright';
import { useHistory } from 'react-router-dom';
import { logout } from '../../../api/auth';
import { userContext } from '../../../utils/userContext';
import { TokenStorage } from '../../../api/auth/TokenStorage';
import { PatchNotes } from "../../patchNotes/patchNoteComponent" 
import { ShortcutKeys } from '../../shortcutKeys';
import { Manuals } from '../../Manuals';

  const drawerWidth = 240;

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      root: {
        display: 'flex',
      },
      appBar: {
        transition: theme.transitions.create(['margin', 'width'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
      },
      appBarShift: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(['margin', 'width'], {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen,
        }),
      },
      menuButton: {
        marginRight: theme.spacing(2),
      },
      profileMenuButton:{ // Placement for the menu button
        display: "flex",
        marginLeft: "auto",
      },
      profileDropdownMenu:{ // Placement for the menu
        display: "flex",
        marginLeft: "auto",
        margin: 15,
        textAlign: "center"
      },
      hide: {
        display: 'none',
      },
      drawer: {
        width: drawerWidth,
        flexShrink: 0,
      },
      drawerPaper: {
        width: drawerWidth,
      },
      drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
        justifyContent: 'flex-end',
      },
      content: {
        flexGrow: 1,
        [theme.breakpoints.up('sm')]: {
          padding: theme.spacing(3),
        },
        [theme.breakpoints.down('sm')]: {
          padding: theme.spacing(0),
        },
        transition: theme.transitions.create('margin', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: -drawerWidth,
      },
      contentShift: {
        transition: theme.transitions.create('margin', {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 0,
      }
    }),
  );

interface Props {
  className?: string
  pageName: string
}

const NavWrapper: FC<Props> = ({ children, pageName }) => {
    const classes = useStyles();
    const history = useHistory();
    const [open, setOpen] = useState(false);
    const { modules, hasModule } = useContext(userContext);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const divRef = React.useRef(null);

    const handleDrawerOpen = () => {
      setOpen(true);
    };

    const handleDrawerClose = () => {
      setOpen(false);
    };

    const handleProfileMenuOpen = () => {
      setAnchorEl(divRef.current);
    };

    const handleProfileMenuClose = () => {
      setAnchorEl(null)
    };

    const updatePage = (path: string) => {
      history.push(path);
    }

    document.addEventListener('keydown', (event) => { // Detects if the user presses "alt" + "shift" + "O" to open the menu
      const keyname = event.key
    
      if (event.altKey && event.shiftKey && keyname === "O") {
        handleDrawerOpen()
      }
    }, false)  
    
    return (
      <div className={classes.root}>
        <CssBaseline />
        <AppBar
          position="fixed"
          className={clsx(classes.appBar, {
            [classes.appBarShift]: open,
          })}
        >
          <Toolbar>
            <IconButton color="inherit" aria-label="open drawer" onClick={handleDrawerOpen} edge="start" className={clsx(classes.menuButton, open && classes.hide)}>
            <MenuIcon />
            </IconButton>
            <Typography variant="h5" noWrap>
              {pageName}
            </Typography>
            <IconButton color='inherit' aria-controls="profile-menu" aria-haspopup="true" onClick={handleProfileMenuOpen} className={clsx(classes.profileMenuButton)}>
            <AccountCircle fontSize="large" />
            </IconButton>
            <div ref={divRef}>
          <Menu id="profile-menu" label="Profile" anchorEl={anchorEl} getContentAnchorEl={null} anchorOrigin={{ vertical: "top", horizontal: "right" }} transformOrigin={{ vertical: "top", horizontal: "right" }} open={Boolean(anchorEl)} onClose={handleProfileMenuClose} className={clsx(classes.profileDropdownMenu)} >
           <MenuItem onClick={handleProfileMenuOpen}> 
           <Typography align = 'center' noWrap>Profil: {TokenStorage.getUserName()} </Typography>
           </MenuItem>
           <MenuItem onClick={() => {logout(); history.push("/login");  }}>
             <IconButton>
            <SvgIcon><SvgLogout/></SvgIcon>
            <Typography align = 'center'  noWrap> Log ud </Typography>
            </IconButton>
          </MenuItem>
          </Menu>
          </div>
          </Toolbar>
        </AppBar>
      <Drawer
        className={classes.drawer}
        variant="persistent"
        anchor="left"
        classes={{
          paper: classes.drawerPaper,
        }}
        open={open}
      >
            <div className={classes.drawerHeader}>
            <IconButton onClick={handleDrawerClose}>
                <ChevronLeftIcon />
            </IconButton>
            </div>
            {/* <Divider />
            <List>{back}</List>  dispatch(push("/mobilbase")); dispatch(push("/infomodul"));*/}
            <Divider />
            <List>
                {modules.map((m, i) => (
                  <Fragment key={i}>
                    {hasModule(m.route) && 
                      <ListItem button onClick={() => updatePage(m.route)} alignItems="flex-start">
                        <ListItemIcon>
                          {m.icon}
                        </ListItemIcon>
                        <ListItemText primary={m.displayName}/>
                        </ListItem>   
                    }
                  </Fragment>          
                ))}
              <ShortcutKeys />
              <PatchNotes />
              <Manuals />
          </List>
        </Drawer>
        {/* <main className={classes.content}> //dispatch(logout({}));*/}
        <main
        className={clsx(classes.content, {
          [classes.contentShift]: open,
        })}
      >
         <div className={classes.drawerHeader} />
         <Container maxWidth={false}>
           <Grid container spacing={3}>
             {children}
          </Grid>
          <Box pt={4}>
            <Copyright />
          </Box>
        </Container>
      </main>
      </div>
    );
  }

export default NavWrapper;